import { PARTNERS } from "@/lib/brand";
import { ShieldCheck } from "lucide-react";

export default function TrustMarquee() {
  const items = [...PARTNERS, ...PARTNERS];
  return (
    <section
      data-testid="trust-marquee"
      className="bg-[#1E3A8A] text-white border-y border-[#1E3A8A]/40"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-5 flex items-center gap-6">
        <div className="hidden sm:flex items-center gap-2 shrink-0 pr-6 border-r border-white/20">
          <ShieldCheck className="h-5 w-5 text-[#67e8c4]" />
          <span className="text-xs font-bold tracking-widest uppercase text-white/90">
            Tie-up with multiple companies
          </span>
        </div>
        <div className="overflow-hidden flex-1 relative">
          <div className="flex gap-10 rk-marquee-track whitespace-nowrap">
            {items.map((p, i) => (
              <span
                key={i}
                className="text-sm sm:text-base font-semibold tracking-wide text-white/85"
              >
                {p}
                <span className="mx-5 text-[#67e8c4]">•</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
